export default __webpack_public_path__ + "static/media/vrikshandolan.d6a30df6.png";